import {gql} from '@apollo/client'

export const EGOV_INFORMATIONS = gql`
  query EgovInformations($procedureStatusId: ID!) {
    client {
      id
      procedureStatus(procedureStatusId: $procedureStatusId) {
        id
        procedureType
        isRelatedRecordsDirty
        employee {
          id
          firstName
          lastName
          currentOffice {
            id
            healthInsuranceType
          }
        }
        egovInformations {
          procedureKind
          procedureCode
          formId
          recommendedAttachments {
            displayName
            required
            note
            key
            formId
          }
          reports {
            kind
            name
          }
        }
        procedureAttachments {
          id
          file
        }
      }
    }
  }
`

export interface EgovInformationsQueryVariables {
  procedureStatusId: string
}

export interface EgovInformationsQueryResult {
  client: {
    id: string
    procedureStatus?: ProcedureStatus
  }
}

export interface ProcedureStatus {
  id: string
  procedureType: string
  isRelatedRecordsDirty: boolean
  employee: {
    id: string
    firstName: string
    lastName: string
    currentOffice?: {
      id: string
      healthInsuranceType?: string
    }
  }
  egovInformations: EgovInformation[]
  procedureAttachments: {
    id: string
    file: {
      filename: string
      url: string
    }
  }[]
}

interface EgovInformation {
  procedureKind: string
  procedureCode: string
  formId: string[]
  recommendedAttachments: {
    displayName: string
    required?: boolean
    note?: string
    key: string
    formId: string
  }[]
  reports: {
    kind: string
    name: string
  }[]
}

export const PREPARE_EGOV_PROCEDURE = gql`
  mutation PrepareEgovProcedure($input: PrepareEgovProcedureInput!) {
    prepareEgovProcedure(input: $input) {
      errors
    }
  }
`

export interface PrepareEgovProcedureQueryVariables {
  input: {
    procedureStatusId: string
    procedureCode: string
    applications: {
      formId: string
      attachments: {
        documentName: string
        file?: File
        procedureAttachmentId?: string
      }[]
    }[]
  }
}

export interface PrepareEgovProcedureQueryResult {
  prepareEgovProcedure: {
    errors: unknown
  }
}
